import React from 'react';

import Bar from './Bar';

const CheckinBar = (props) => {
    if (!props.checkins) {
        return null;
    }

    const checkins = props.checkins;

    return (
        <div className="CheckinBar">
            {['1', '2', '3'].map((checkinKey) => {
                let percentage = 0;
                if (
                    checkins[checkinKey].planned > 0 &&
                    checkins[checkinKey].ready > 0
                ) {
                    percentage =
                        (checkins[checkinKey].ready /
                            checkins[checkinKey].planned) *
                        100;
                }

                return (
                    <div key={checkinKey} className="CheckinStatusBar">
                        <div className="Checkin">
                            <Bar
                                orientation="horizontal"
                                status={checkins[checkinKey].criticality}
                                completed={percentage}
                            />
                            <p>
                                {checkins[checkinKey].ready} /{' '}
                                {checkins[checkinKey].planned}
                            </p>
                        </div>
                        <div className="Label">Check-in {checkinKey}</div>
                    </div>
                );
            })}
        </div>
    );
};

export default CheckinBar;
